
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Trainings from "../pages/trainings/page";
import Contact from "../pages/contact/page";
import Blog from "../pages/blog/page";
import Sitemap from "../pages/sitemap/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/egitimler",
    element: <Trainings />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/iletisim",
    element: <Contact />,
  },
  {
    path: "/sitemap",
    element: <Sitemap />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
